module.exports = __webpack_public_path__ + "img/eg-19-01.bae22afe.jpg";